import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';
import { useMemo } from 'react';

import useTranslation from '../../hooks/useTranslation';
import SelectField from '../SelectField/SelectField';

type Props = {
    name: string;
    label: string;
};

const SectorField = ({ name, label }: Props) => {
    const translate = useTranslation();
    const sectorOptions: SelectFieldOption[] = useMemo<SelectFieldOption[]>(
        () => [
            { id: 'HEALTHCARE', label: translate('field.sector.option.healthcare.label') },
            { id: 'EDUCATION', label: translate('field.sector.option.education.label') },
            { id: 'SERVICES', label: translate('field.sector.option.services.label') },
            { id: 'INDUSTRY', label: translate('field.sector.option.industry.label') },
            { id: 'TRANSPORTATION', label: translate('field.sector.transportation.label') },
            { id: 'OTHER', label: translate('field.sector.option.other.label') },
        ],
        [translate],
    );

    return (
        <SelectField label={label} name={name}>
            {sectorOptions}
        </SelectField>
    );
};

export default SectorField;
